import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GoodPracticesService } from './../../../services/goodPractices/goodPractices.service';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { VideoModalComponent } from '../../../modals/video-modal/video-modal.component';
//import { GroupProjectModalComponent } from '@app/modales/group-project-modal/group-project-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-good-practices-details',
  templateUrl: './good-practices-details.component.html',
  styleUrls: ['./good-practices-details.component.scss']
})
export class GoodPracticesDetailsComponent implements OnInit {

  token:string;
  goodPractice:any = {};
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[] = [];

  constructor(
    private GoodPracticesService:GoodPracticesService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    public sanitizer: DomSanitizer

  ) { }

  ngOnInit() 
  {

    this.token = this.route.snapshot.paramMap.get("token");
    this.getPractice();
    this.initGalery();
  }

  safeUrlVideo(url)
  {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  getPractice()
  {
    this.GoodPracticesService.getPracticeDetails(this.token).subscribe(goodPractice => {
         this.goodPractice = goodPractice;

                       let i;             


                       if(goodPractice['photosList'])
                       {
                                 for (i = 0; i < goodPractice['photosList'].length; i++) 
                                  {                            

                                         this.galleryImages.push({                                     
                                                 small:  goodPractice['photosList'][i]['image'],
                                                 medium:  goodPractice['photosList'][i]['image'],
                                                 big:  goodPractice['photosList'][i]['image']                                                      
                                           });     

                                  }   
                       }   
                    
    })
  }

  initGalery()
  {
    this.galleryOptions = [
            {
              "previewCloseOnClick": true,
               "previewCloseOnEsc": true, 
              "thumbnailsRemainingCount": true,
              image: false,
              width: '100%', 
              height: '200px', 
              thumbnailsColumns: 4,
               thumbnailsRows: 1,
                thumbnailsPercent: 100,
                 imagePercent: 100,
                  thumbnailMargin: 10,
                   thumbnailsMargin: 10,
                    thumbnailsOrder: 3,
              imageAnimation: NgxGalleryAnimation.Slide
            },
            {
                    breakpoint: 500,
                    width: '100%',
                    thumbnailsColumns: 2
            }
         
        ];
 
      
  } 

openModalVideo(src)
{
    const modal = this.modalService.open(VideoModalComponent,{ size: 'lg', centered : true });
    modal.componentInstance.src = src;
}


}
